/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import styled from 'styled-components';
import { theme } from '../common/utilsClient/cssHelpers';

const Component = styled.div`
  height: 100%;

  /* color: ${theme('color.onBackground')}; */

  h2 {
    ${theme('typography.title2')};
  }

  a {
    color: ${theme('color.primary')};

    &:hover {
      color: ${theme('color.primaryHover')};
    }
  }
`;

export default (props) => <Component {...props} />;
